import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Download from '@/components/Download'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/download',
      name: 'Download',
      component: Download
    }
  ]
})

router.beforeEach((to, from, next) => {
  // This prevents the user from accessing the /download path directly
  if (from.name == null && to.name === 'Download') {
    next('/')
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js